/**
 * Created by staffanrantzow on 01/11/16.
 */

import React, { PropTypes } from 'react';
import { Spinner, GeneralError } from 'components';
import { UserService } from 'frilans-finans';
import { Link } from 'react-router';
import Translate from 'react-translate-component';

class ActivateAccount extends React.Component {

  static propTypes = {
    location: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      fetching: true,
      error: false
    };
  }

  componentDidMount () {
    UserService.activateAccount(this.props.location.query.id, this.props.location.query.token)
      .then(this.handleResponse.bind(this))
      .catch(this.handleError.bind(this));
  }

  handleResponse () {
    this.setState({
      fetching: false,
      error: false
    });
  }

  handleError () {
    this.setState({
      fetching: false,
      error: true
    });
  }

  renderContent () {
    if (this.state.fetching) {
      return (<Spinner/>);
    }
    if (this.state.error) {
      return (<GeneralError/>);
    }

    return (
      <div>
        <p className="info"><Translate content='ACCOUNT_ACTIVATED' /></p>
        <Link to='/login?tab=EMAIL' className='btn'><Translate content='LOGIN' /></Link>
      </div>
    );
  }

  render () {
    return (
      <div className="container page mt35 mb70">
        <div className="row">
          <div className="col-sm-12">
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }

}

export default ActivateAccount;



/** WEBPACK FOOTER **
 ** ./src/views/activate-account/activate-account.js
 **/